import Multiselect from "vue-multiselect";
import { VueAutosuggest } from "vue-autosuggest";
import debounce from "lodash/debounce";

import {
  GET_SUGGESTIONS,
  GET_ADDRESSES
} from "../../../gql/UserProfileQueries";

import { required, minValue, maxValue } from "vuelidate/lib/validators";

export default {
  name: "filter-field",

  data() {
    return {
      selected: null,

      placesQuery: "",
      placesRequestQuery: "",
      places: [],
      skipPlacesQuery: true,

      addresses: [],
      skipAddressesQuery: true,

      getUser: {},
      skipGetUserQuery: true
    };
  },

  props: ["filter"],

  validations() {
    let params = {};

    if (this.filter.type == "price") {
      params.selected = {
        required,
        minValue: minValue(this.filter.values[0]),
        maxValue: maxValue(1999999999)
      };
    }

    return params;
  },

  apollo: {
    places: {
      query: GET_SUGGESTIONS,
      variables() {
        return {
          address: this.placesRequestQuery
        };
      },

      skip() {
        return this.skipPlacesQuery;
      },
      result() {
        this.skipPlacesQuery = true;
      }
    },

    addresses: {
      query: GET_ADDRESSES,
      variables() {
        return {
          input: this.addressesRequestQuery
        };
      },
      skip() {
        return this.skipAddressesQuery;
      },
      result() {
        this.skipAddressesQuery = true;
      }
    }
  },

  computed: {
    fieldOptions() {
      if (this.filter && this.filter.values) {
        return this.filter.values;
      } else {
        return [];
      }
    },

    filteredOptions() {
      const filtered = [];

      if (!this.placesQuery) {
        return [];
      }

      let options = [];

      if (this.filter.type == "exact_location") {
        options = this.addresses;
      } else {
        options = this.places;
      }

      options.forEach(r => {
        filtered.push({
          label: r.type,
          data: r.places,
          limit: 5,
          onSelected: selected => {
            this.selected = selected.item;
          }
        });
      });

      return Object.freeze(filtered);
    }
  },

  mounted: function() {
    switch (this.filter.type) {
      case "main_desired_location":
      case "additional_location":
      case "exact_location":
        this.placesQuery = this.filter.selectedValue;
        break;

      case "multi_select":
        this.selected = JSON.parse(this.filter.selectedValue);
        break;

      case "price":
        this.selected = JSON.parse(this.filter.selectedValue)[1];
        break;

      default:
        this.selected = this.filter.selectedValue;
        break;
    }
  },

  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    changeFilterField(filter) {
      let currentFilter = {
        tagId: +filter.tagId,
        value: JSON.stringify(this.selected)
      };

      // only for PRICE -> []
      if (filter.type == "price") {
        currentFilter.value = JSON.stringify([0, parseInt(this.selected)]);
      }

      this.$emit("updateSearchParams", currentFilter);
    },

    // Select Places
    selectHandler(item) {
      let currentFilter = {
        tagId: +this.filter.tagId,
        value: JSON.stringify(item.item.placeId)
      };

      this.$emit("updateSearchParams", currentFilter);
    },

    getSuggestionValue(suggestion) {
      return suggestion.item.description;
    }
  },

  watch: {
    placesQuery: debounce(function(newQuestion) {
      if (newQuestion && newQuestion.length >= 2) {
        if (this.filter.type == "exact_location") {
          // trigger ADDRERSSES request
          this.addressesRequestQuery = newQuestion;
          this.skipAddressesQuery = false;
        } else {
          // trigger PLACES request
          this.placesRequestQuery = newQuestion;
          this.skipPlacesQuery = false;
        }
      }
    }, 300)
  },

  components: {
    Multiselect,
    VueAutosuggest
  }
};
